<template>
  <div>
    <!-- Usage dashboard UI -->
  </div>
</template>
<script setup lang="ts">
// ...existing code...
</script>
